import { Page, Layout, Card } from "@shopify/polaris";
import React from "react";

const COPY = {
  server_error: {
    title: "Unable to retrieve your account",
    paragraphs: [
      "We're unable to retrieve your account information at this time.",
      "Please check your WordPress logs for any errors and make sure it's accessible to the internet.",
      "You can refresh the page to try again.",
    ],
  },
  corrupted_response: {
    title: "WordPress is returning corrupted API responses",
    paragraphs: [
      "Real ID couldn't read the response from your WordPress site — the response body contained unexpected HTML mixed with our JSON data.",
      "This is almost always caused by another plugin or theme echoing output during REST API requests. Common culprits are caching/optimization plugins, page builders, and themes that call wp_head() too early.",
      "Try deactivating recently-installed plugins one at a time and refreshing this page. If the issue persists, contact support with a list of your active plugins.",
    ],
  },
};

export default function UnableToRetrieveShop({ reason = "server_error" }) {
  const { title, paragraphs } = COPY[reason] || COPY.server_error;

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Card
            title={title}
            primaryFooterAction={{
              content: "Refresh",
              onClick: () => location.reload(true),
            }}
            secondaryFooterActions={[
              {
                content: "Contact Support",
                url: "https://getverdict.com/help/contact",
              },
            ]}
          >
            <Card.Section>
              {paragraphs.map((text, i) => (
                <p key={i} className={i < paragraphs.length - 1 ? "mb-5" : ""}>
                  {text}
                </p>
              ))}
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
